<template>
  <div class="form-group">
    <label>{{ question.statement }}</label>
    <p class="text-red" v-if="m_error">{{ m_error }}</p>

    <div class="row">
      <div
        v-for="(row, rowIndex) in rows"
        :key="row.id"
        :class="[ rowsLength === 1 ? 'col-xs-12' : 'col-sm-6' ]"
      >
        <div class="box">
          <div class="box-body">
            <component
              v-for="(field, fieldIndex) in question.fields"
              :key="`field-${row.id}-${field.uuid}`"
              :is="getFieldComponent(field)"
              :field="field"
              :fieldAnswer="getFieldAnswer(rowIndex, field)"
              :isDisabled="disabledAttribute"
              @fieldUpdated="onFieldUpdated"
            ></component>

            <button
              v-if="!disabledAttribute"
              class="btn btn-sm btn-default center-block pull-right"
              @click.prevent="removeRow(rowIndex)"
            >
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!disabledAttribute">
      <div class="col-xs-12">
        <button
          class="btn btn-sm btn-default center-block"
          @click.prevent="addRow"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CNPJField from './fields/CNPJField'
import CPFField from './fields/CPFField'
import StringField from './fields/StringField'
import YearField from './fields/YearField'
import EmailField from './fields/EmailField'
import PhoneNumberField from './fields/PhoneNumberField'
import MultipleChoiceField from './fields/MultipleChoiceField'
import IntegerField from './fields/IntegerField'
import MoneyField from './fields/MoneyField'

export default {
  props: ['question', 'answer', 'isDisabled'],
  name: 'CollectionQuestion',

  data () {
    return {
      m_error: null,
      componentsPerType: {
        cnpj: CNPJField,
        cpf: CPFField,
        string: StringField,
        year: YearField,
        email: EmailField,
        phone_number: PhoneNumberField,
        'multiple-choice': MultipleChoiceField,
        integer: IntegerField,
        money: MoneyField
      },
      rows: [],
      rowCounter: 0
    }
  },

  mounted () {
    this.sortQuestionFieldsByRenderingOrder(this.question)

    if (this.answer.value) {
      this.rows = this.answer.value.map(oldRow => ({
        id: this.rowCounter++,
        fields: oldRow
      }))
    }

    if (this.rowsLength === 0) {
      this.addRow()
    }
  },

  computed: {
    rowsLength () {
      return this.rows.length
    },
    disabledAttribute () {
      return this.question.disabled === true || this.isDisabled === true
    }
  },

  watch: {
    rows: {
      deep: true,
      handler () {
        const formatted = this.rows
          .map(r => r.fields)
          .filter(this.notEmptyRow)

        this.$emit('answerUpdated', {
          questionUuid: this.question.uuid,
          value: formatted
        })
      }
    }
  },

  methods: {
    onFieldUpdated (rowIndex, newFieldAnswer) {
      const row = this.rows[rowIndex].fields
      const field = row.find(f => f.fieldUuid === newFieldAnswer.fieldUuid)
      if (field) {
        field.value = newFieldAnswer.value
      }
    },

    removeRow (rowIndex) {
      this.rows.splice(rowIndex, 1)
    },

    addRow () {
      const emptyFields = this.question.fields.map(field => ({
        fieldUuid: field.uuid,
        value: null
      }))

      this.rows.push({
        id: this.rowCounter++,
        fields: emptyFields
      })
    },

    getFieldComponent (f) {
      return this.componentsPerType[f.type]
    },

    getFieldAnswer (rowIndex, field) {
      const row = this.rows[rowIndex].fields
      const answer = row.find(r => r.fieldUuid === field.uuid)

      return {
        rowIndex,
        value: answer ? answer.value : null
      }
    },

    sortQuestionFieldsByRenderingOrder (question) {
      question.fields.sort((a, b) => a.renderingOrder - b.renderingOrder)
      return question
    },

    notEmptyRow (row) {
      return row.some(field => field.value !== null && field.value !== '')
    },

    isValid () {
      this.m_error = null

      let areFieldAnswersBlank = true
      for (let r of this.rows) {
        for (let f of r.fields) {
          if (f.value) {
            areFieldAnswersBlank = false
          }
        }
      }

      if (!this.question.required && areFieldAnswersBlank) {
        this.rows = []
        return true
      }

      if (this.question.required && areFieldAnswersBlank) {
        this.m_error = 'Esta questão é de preenchimento obrigatório'
        return false
      }

      let areFieldAnswersValid = true
      const fields = this.$refs.fields || []

      fields.forEach(field => {
        if (!field.isValid()) {
          areFieldAnswersValid = false
        }
      })

      return areFieldAnswersValid
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionQuestion.vue?2c108edc